import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "copy" }
const _hoisted_3 = { class: "kicker" }
const _hoisted_4 = { class: "home-stagger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_home_reveal = _resolveDirective("home-reveal")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    class: "audience",
    "aria-label": _ctx.t('whoIsThisAppFor')
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('discoverColorText')), 1),
      _createElementVNode("h2", null, _toDisplayString(_ctx.t('whoIsThisAppFor')), 1)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audience, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.titleKey
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.t(item.titleKey)), 1)
        ]))
      }), 128))
    ])
  ], 8, _hoisted_1)), [
    [_directive_home_reveal]
  ])
}